import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
export var ProviderRpcError = /*#__PURE__*/function (_Error) {
  _inherits(ProviderRpcError, _Error);
  var _super = _createSuper(ProviderRpcError);
  function ProviderRpcError(error) {
    var _this;
    _classCallCheck(this, ProviderRpcError);
    _this = _super.call(this, error.message);
    _this.message = error.message;
    _this.code = error.code;
    _this.data = error.data;
    return _this;
  }
  return _createClass(ProviderRpcError);
}( /*#__PURE__*/_wrapNativeSuper(Error));